<script>
import options from './SuccessPage.options'
export default options
</script>

<template>
  <article class="kb-success-page">
    <section class="kb-success-page__hero">
      <div class="kb-success-page__hero__title-wrapper">
        <div class="kb-success-page__hero__hero-title-circle">
          <div class="kb-success-page__hero__hero-title-icon">
            <svg
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 6.58696L4.25 10.5L10.5 0.5"
                stroke="white"
                stroke-width="1.25"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <h1 class="kb-success-page__hero__title-wrapper__title">
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'successTitle'
            })
          }}
        </h1>
      </div>
      <div class="kb-success-page__breaker">
        <svg viewBox="0 0 81 11" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z"
          />
        </svg>
      </div>
      <p class="kb-success-page__success-text">
        {{
          getLabel({
            labelCollection: 'signUpForm',
            labelKey: 'successConfirmation'
          })
        }}
      </p>
    </section>
    <div class="kb-success-page__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z"
        />
      </svg>
    </div>
    <section class="kb-success-page__content-container">
      <p class="kb-success-page__paragraph">
        {{
          getLabel({
            labelCollection: 'signUpForm',
            labelKey: 'successParagraph',
            allowEmpty: true
          })
        }}
      </p>
      <div v-if="succesButtonData" class="kb-success-page__button-wrapper">
        <a
          :href="succesButtonData.href"
          :target="succesButtonData.target"
          class="kb-button kb-button--full-color-spot"
          >{{ succesButtonData.title }}</a
        >
      </div>
      <div class="kb-success-page__privacy-policy-info">
        <p
          class="kb-success-page__privacy-policy-info__text"
          v-html="
            getLabel({ labelCollection: 'signUpForm', labelKey: 'privacyText' })
          "
        ></p>
      </div>
    </section>
  </article>
</template>
